import ScriptHelper from "base/ScriptHelper";
import AbstractVideo from "video/AbstractVideo";

export default class YoutubeVideo extends AbstractVideo {

    constructor(data, $element, settings = {}) {
        super(data, $element, settings);

        this.initialisePlayer();
    }

    play() {
        this.player.playVideo();
    }

    pause() {
        this.player.pauseVideo();
    }

    stop() {
        this.player.stopVideo();
    }

    seek(time) {
        this.player.seekTo(time, true);
    }

    setVolume(volume) {
        this.player.setVolume(volume * 100);
    }

    initialisePlayer() {
        if ($("#" + this.element_id).length === 0) throw new Error("The video element must be on the page before initialising the player");

        YoutubeVideo.load_js().then(() => {
            this.player = new YT.Player(this.element_id, {
                videoId: this.video_id,
                playerVars: {
                    modestbranding: true,
                    showinfo: false,
                    rel: 0,
                    autoplay: this.settings.autoplay ? 1 : 0,
                    autohide: 1,
                },
                events: {
                    "onReady": (event) => {
                        this.emit("loaded");
                    },
                    "onStateChange": (event) => {
                        if (event.data === YT.PlayerState.ENDED) {
                            this.emit("ended");
                        } else if (event.data === YT.PlayerState.PLAYING) {
                            this.emit("play");
                        } else if (event.data === YT.PlayerState.PAUSED) {
                            this.emit("pause");
                        }
                    },
                },
            });
        }).catch((e) => {
            console.error("Couldn't load YouTube iframe API", e);
        });
    }

    destroy() {
        super.destroy();

        this.player.destroy();
        this.player = null;
    }

    static load_js() {
        return ScriptHelper.load_script('https://www.youtube.com/iframe_api').then(() => {
            if (YT.loaded) {
                return;
            }

            return new Promise((resolve) => {
                YT.ready(resolve);
            });
        });

    }

    static get_video_details(videoId) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: "https://www.googleapis.com/youtube/v3/videos",
                data: {
                    id: videoId,
                    key: window.CONFIG.gallery.youtubeKey,
                    fields: "items(snippet(title,thumbnails(maxres,high)),contentDetails(duration))",
                    part: "snippet,contentDetails",
                },
                dataType: "json",
            }).done((data) => {
                if (data.items.length !== 1) {
                    reject("Unknown video");
                } else {
                    resolve({
                        id: videoId,
                        name: data.items[0].snippet.title,
                        duration: data.items[0].contentDetails.duration.replace(/[PTS]/g, "").replace(/[^0-9]/g, ":"),
                        image: data.items[0].snippet.thumbnails.maxres ? data.items[0].snippet.thumbnails.maxres.url : data.items[0].snippet.thumbnails.high.url,
                        provider: "youtube.com",
                    });
                }
            }).fail(() => {
                reject("Connection error");
            });
        });
    }
}

